import angularJsUtilitiesModule from "../angularJsUtilitiesModule";

function chatDispatchService(hybridService, $document, $log) {
    "ngInject";
        return {
            startChat: function (userId, chatPermissionVerifier) {
                if (chatPermissionVerifier.androidApp.isEnabled && chatPermissionVerifier.androidApp.hybridRequired) {
                    var params = { userIds: [] };
                    params.userIds.push(userId);
                    hybridService.startChatConversation(params);
                } else if (chatPermissionVerifier.iOSApp.isEnabled && chatPermissionVerifier.iOSApp.hybridRequired) {
                    hybridService.startWebChatConversation(userId);
                } else if (chatPermissionVerifier.uwpApp.isEnabled && chatPermissionVerifier.uwpApp.hybridRequired) {
                    hybridService.startWebChatConversation(userId);
                } else {
                    $document.triggerHandler("Roblox.Chat.StartChat", { userId: userId });
                }
            },

            buildPermissionVerifier: function (library) {
                var result = {
                    androidApp: {
                        isEnabled: library.inAndroidApp,
                        hybridRequired: true
                    },
                    iOSApp: {
                        isEnabled: library.iniOSApp,
                        hybridRequired: true
                    },
                    uwpApp: {
                        isEnabled: library.inUWPApp,
                        hybridRequired: false
                    }
                };
                return result;
            }
        }
}

angularJsUtilitiesModule.factory("chatDispatchService", chatDispatchService);

export default chatDispatchService;